import { default as BgStandard } from './BgStandard';
import { default as IconBgStandard } from './IconBgStandard';

const EXPORT = { BgStandard, IconBgStandard };

export default EXPORT;
